import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Candidate } from '../models';
import { ApiParams, ApiService } from './api.service';

@Injectable()
export class CandidateService extends ApiService<Candidate> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'candidate/';
  }

  postByEmail(body: Partial<Candidate>): Observable<any> {
    return this.post({ url: 'save-or-update-by-email', body });
  }

  autocomplete(apiParams: ApiParams): Observable<Candidate[]> {
    return this.get({ url: 'autocomplete', params: apiParams });
  }

  searchCandidates(
    searchPhrase: string,
    apiParams: ApiParams,
    hasAnonymization = false,
  ): Observable<any> {
    if (!!hasAnonymization) {
      apiParams = { ...apiParams, anonymization: hasAnonymization };
    }
    return this.get({
      url: 'search',
      params: { name: searchPhrase, ...apiParams },
    });
  }

  mergeCandidates(emailId: string, primaryCandidateId: number): Observable<Candidate> {
    return this.patch({
      url: `merge-candidates/${emailId}?primaryCandidateId=${primaryCandidateId}`,
    });
  }
}
